import { render, staticRenderFns } from "./headertabtwo.vue?vue&type=template&id=e47c3a06&scoped=true&"
import script from "./headertabtwo.vue?vue&type=script&lang=js&"
export * from "./headertabtwo.vue?vue&type=script&lang=js&"
import style0 from "./headertabtwo.vue?vue&type=style&index=0&id=e47c3a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47c3a06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e47c3a06')) {
      api.createRecord('e47c3a06', component.options)
    } else {
      api.reload('e47c3a06', component.options)
    }
    module.hot.accept("./headertabtwo.vue?vue&type=template&id=e47c3a06&scoped=true&", function () {
      api.rerender('e47c3a06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chronic/headertabtwo.vue"
export default component.exports